import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { InputParameterService } from "@tylertech/search-module";
import
{
    ExecutionResult,
    IVendorAddressLookupService,
    InputParameter,
    LookupCriteria,
    VendorAddressViewModel,
} from "@tylertech/tyler-api-types";

/**
 * TODO - This should be generated with the ExpressService attribute in Tyler.Api
 */
@Injectable()
export class VendorAddressService implements IVendorAddressLookupService
{
    constructor(
        private readonly $apiService: ApiService,
        private readonly $inputParameterService: InputParameterService) { }

    CanEdit(): Promise<boolean>
    {
        return this.$apiService.sendAuth("IVendorAddressLookupService/CanEdit");
    }

    Get(vendorAddressId: string): Promise<VendorAddressViewModel>
    {
        return this.$apiService.sendAuth(
            "Tyler/API/AccountsPayable/Services/Lookup/IVendorAddressLookupService/Get",
            vendorAddressId
        );
    }

    Lookup(criteria: LookupCriteria): Promise<ExecutionResult<VendorAddressViewModel[]>>
    {
        return this.$apiService.sendAuth(
            "Tyler/API/AccountsPayable/Services/Lookup/IVendorAddressLookupService/Lookup",
            criteria
        );
    }

    Save(model: VendorAddressViewModel): Promise<boolean>
    {
        return this.$apiService.sendAuth(
            "Tyler/API/AccountsPayable/Services/Lookup/IVendorAddressLookupService/Save",
            model
        );
    }

    private addVendorIdParameter(id: string, parameters: InputParameter[]): void
    {
        if (!id)
        {
            return;
        }
        parameters.push(
            this.$inputParameterService.createBooleanParameter({
                Label: "Id",
                FieldId: "VendorId",
                Value: id,
            })
        );
    }

    lookup(vendorId: string, value?: string, remit?: boolean): Promise<VendorAddressViewModel[]>
    {
        const criteria: LookupCriteria = <LookupCriteria>{
            Parameters: [],
            SearchText: value,
        };
        this.addVendorIdParameter(vendorId, criteria.Parameters);
        if (remit)
        {
            criteria.Parameters.push(
                this.$inputParameterService.createBooleanParameter({
                    Label: "Remit",
                    FieldId: "Remit",
                    Value: remit,
                    IsVisible: false,
                })
            );
        }
        return this.Lookup(criteria)
            .then(x => x.Result);
    }

    lookupPrimaryBusiness(vendorId?: string): Promise<VendorAddressViewModel[]>
    {
        const criteria: LookupCriteria = <LookupCriteria>{ Parameters: [] };
        this.addVendorIdParameter(vendorId, criteria.Parameters);
        criteria.Parameters.push(
            this.$inputParameterService.createBooleanParameter({
                Label: "Default",
                FieldId: "IsPrimaryBusiness",
                Value: "True",
                IsVisible: false,
            })
        );
        return this.Lookup(criteria)
            .then(x => x.Result);
    }

    lookupPrimaryRemittance(vendorId?: string): Promise<VendorAddressViewModel[]>
    {
        const criteria: LookupCriteria = <LookupCriteria>{ Parameters: [] };
        this.addVendorIdParameter(vendorId, criteria.Parameters);
        criteria.Parameters.push(
            this.$inputParameterService.createBooleanParameter({
                Label: "Default",
                FieldId: "IsPrimaryRemittance",
                Value: "True",
            })
        );
        return this.Lookup(criteria)
            .then(x => x.Result);
    }
}
